export default async function runSsrSafely(promises, logger) {
    const list = Array.isArray(promises) ? promises : [promises];
    const results = await Promise.allSettled(list);
    results.forEach((result, index) => {
        if (result.status === 'rejected') {
            const message = result.reason?.message || result.reason;
            (logger || console).warn('[SSR] fetch failed', index, message);
        }
    });
    return results;
}
